export function mobileMenu() {
  const html = document.documentElement;
  const menuBtn = document.querySelector(".btn-menu");
  const menuMobile = document.querySelector(".mobile-menu");

  if (!menuBtn || !menuMobile) {
    return;
  }

  menuBtn.addEventListener("click", function () {
    menuBtn.classList.toggle("active");
    html.classList.toggle("overflow-hidden");
    menuMobile.classList.toggle("active");
  });
}
